import { StatusBadge } from "@/components/common/StatusBadge";
import { unitLabelFor } from "@/components/common/UnitPicker";
import { stockStatus } from "@/lib/expiry";
import { formatMoney, formatQuantity } from "@/lib/format";
import { cn } from "@/lib/utils";
import type { ProductStockItemDto } from "@/types/stock.types";

/** One tap adds a line: no dialog between the shelf and the basket. */
export function ProductGrid({
  items,
  currency,
  onPick,
}: {
  items: ProductStockItemDto[];
  currency: string;
  onPick: (item: ProductStockItemDto) => void;
}) {
  return (
    <ul className="grid grid-cols-2 gap-3 lg:grid-cols-3">
      {items.map((item) => {
        const status = stockStatus(item.quantity, item.expiryDate);
        const soldOut = status === "out";

        return (
          <li key={item.product.id}>
            <button
              type="button"
              disabled={soldOut}
              onClick={() => onPick(item)}
              className={cn(
                "flex h-full w-full flex-col justify-between gap-3 rounded-xl border p-4 text-left transition",
                soldOut
                  ? "cursor-not-allowed border-border bg-muted/40 opacity-60"
                  : "border-input bg-card hover:border-foreground",
              )}
            >
              <span className="font-semibold leading-tight">{item.product.name}</span>

              <span className="flex flex-wrap items-center justify-between gap-2">
                <span className="text-lg font-semibold tabular-nums">{formatMoney(item.product.price, currency)}</span>
                {soldOut ? (
                  <StatusBadge tone="danger">Épuisé</StatusBadge>
                ) : (
                  <StatusBadge tone={status === "expiring" ? "warning" : "ok"}>
                    {formatQuantity(item.quantity, unitLabelFor(item.product.measurementUnit, item.quantity))}
                  </StatusBadge>
                )}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
